import {
  PROCESSING,
  GET_TYPES,
  GET_METADATA,
  START_VALIDATION_RESULT,
  GET_VALIDATION_RESULT,
  START_BULK_UPLOAD_REQUEST,
  END_BULK_UPLOAD_REQUEST,
  GET_BULK_REQUESTS,
  GET_BULK_REQUESTS_COUNT,
  UPLOAD_BULK_REQUEST,
  GET_ITEMS,
  GET_ITEM_COUNT,
  ABORT_BULK_UPLOAD,
} from '../actions/bulkuploadv2/bulkuploadv2.actiontype';

const initialState = {
  isFirstTimeLoad: true,
  isProcessing: false,
  isUploading: false,
  bulkRequests: [],
  bulkRequestsCount: 0,
  items: [],
  itemsCount: 0,
  types: [],
  metadata: {},
  validationResult: {},
  uploaded: false,
  abortedId: null,
};

const BulkUpload = (state = initialState, action) => {
  switch (action.type) {
    case PROCESSING: {
      if (state.isFirstTimeLoad && action.payload) {
        return {
          ...state,
          isProcessing: true,
          isFirstTimeLoad: false,
        };
      } else {
        return {
          ...state,
          isProcessing: false,
        };
      }
    }

    case GET_TYPES: {
      return {
        ...state,
        types: action.payload,
      };
    }

    case GET_METADATA: {
      return {
        ...state,
        metadata: action.payload,
      };
    }

    case START_VALIDATION_RESULT: {
      return {
        ...state,
        isProcessing: true,
        validationResult: {},
      };
    }

    case GET_VALIDATION_RESULT: {
      return {
        ...state,
        isProcessing: false,
        validationResult: action.payload,
      };
    }

    case GET_BULK_REQUESTS_COUNT: {
      return {
        ...state,
        bulkRequestsCount: action.payload,
      };
    }

    case GET_ITEMS: {
      return {
        ...state,
        items: action.payload,
      };
    }

    case GET_ITEM_COUNT: {
      return {
        ...state,
        itemsCount: action.payload,
      };
    }

    case START_BULK_UPLOAD_REQUEST: {
      return {
        ...state,
        isUploading: true,
      };
    }

    case END_BULK_UPLOAD_REQUEST: {
      return {
        ...state,
        isUploading: false,
      };
    }

    case GET_BULK_REQUESTS: {
      return {
        ...state,
        bulkRequests: action.payload,
      };
    }

    case UPLOAD_BULK_REQUEST: {
      return {
        ...state,
        uploaded: action.payload,
        isUploading: false,
      };
    }

    case ABORT_BULK_UPLOAD: {
      return {
        ...state,
        abortedId: action.payload,
      };
    }

    default:
      return state;
  }
};

export default BulkUpload;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
